import { NAVIGATE_FROM } from './../actions/epg';

const STATE = {
  place : ''
}

const reducer = (state = STATE, action) => {
  switch(action.type){
    case NAVIGATE_FROM:
      return {
        ...state,
        place: action.payload
      }
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/epg.js